// @flow

import util from 'util';

import _ from 'lodash';

import ko from 'rgs-knockout';
import type { ObservableArray } from 'rgs-knockout';

import { StepsBase } from './steps-base';
import type { StepsOptions } from './steps-base';
import type { Step, StepId, StepOptions } from './step';


// Steps where any number of steps can be open simultaniously (hence mutually inclusive)
export class StepsMutuallyInclusive extends StepsBase {
	_OpenSteps: ObservableArray<Step>;

	constructor (options: Array<StepOptions> | StepsOptions) {
		super(options);

		this._OpenSteps = ko.observableArray();

		this._OpenSteps.subscribe((changes) => {
			_.each(changes, (change) => {
				if ('moved' in change) {
					return;
				}

				const step = change.value;

				if (change.status === 'deleted') {
					this.emit('close', step);
					this.emit(util.format('close-%s', step.id), step);
				} else if (change.status === 'added') {
					this.emit('open', step);
					this.emit(util.format('open-%s', step.id), step);

					this._analyticsHelper
						.sendOpenStepEvent(step.id, this._withAllClosedInProgress());
				}
			});
		}, this, 'arrayChange');
	}

	_defaultOptions () {
		return _.defaults({
			scroll: false,
		}, super._defaultOptions());
	}

	_stepSummaryClick (step: Step) {
		if (step.Locked()) {
			return;
		}
		this.open(step);
	}

	isOpen (id: Step | StepId) {
		return _.includes(this._OpenSteps(), this.get(id));
	}

	open (id: Step | StepId) {
		if (this.isOpen(id)) {
			return;
		}
		this._OpenSteps.push(this.get(id));
	}

	openEach (ids: Array<Step | StepId>) {
		_.each(ids, id => this.open(id));
	}

	isClosed (id: Step | StepId) {
		return !this.isOpen(id);
	}

	close (id: Step | StepId) {
		if (this.isClosed(id)) {
			return;
		}
		this._OpenSteps.remove(this.get(id));
	}

	closeEach (ids: Array<Step | StepId>) {
		_.each(ids, id => this.close(id));
	}

	closeAll () {
		this._OpenSteps.removeAll();
	}
}
